import axios from "axios";
let url
switch (window.location.hostname) {
  case 'local.quinielazo.com':
    url = 'https://api-local.quinielazo.com'
    break;
  case 'dev.quinielazo.com':
    url = 'https://api-dev.quinielazo.com'
    break;
  default:
    url = 'https://api.quinielazo.com'
    break;
}
const api = url

const apiClient = axios.create({
  baseURL: api,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-type": "application/json"
  }
});

export default {
  getAxiosObject() {
    return apiClient;
  },
  setToken(token) {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  },
  setxSocketId(id) {
    apiClient.defaults.headers.common["X-Socket-Id"] = id;
  },
  getEquipos() {
    return apiClient.get("/equipos");
  },
  getEquipo(id) {
    return apiClient.get("/equipos/" + id);
  },
  postEquipo(equipo) {
    return apiClient.post("/equipos", equipo);
  },
  updateEquipo(equipo) {
    return apiClient.post("/equipos/" + equipo.id, equipo);
  },
  updateEquipoImg(id, data) {
    return apiClient.post("/equipos/" + id, data, {
      headers: {
        "Content-type": "multipart/form-data"
      }
    });
  },
  getPartidos(url = false) {
    if (url) {
      return apiClient.get(url);
    } else {
      return apiClient.get("/partidos");
    }
  },
  getPartido(id) {
    return apiClient.get("/partidos/" + id);
  },
  postPartido(partido) {
    return apiClient.post("/partidos", partido);
  },
  updatePartido(partido) {
    return apiClient.post("/partidos/" + partido.id, partido);
  },
  getPartidosDisponibles() {
    //Partidos para jugar quinielas
    return apiClient("/partidos-disponibles");
  },
  getLigas(equipos) {
    if (equipos) {
      return apiClient.get("/ligas?with=equipos");
    } else {
      return apiClient.get("/ligas");
    }
  },
  getLiga(id) {
    return apiClient.get("/ligas/" + id);
  },
  postLiga(liga) {
    return apiClient.post("/ligas", liga);
  },
  updateLiga(liga) {
    return apiClient.post("/ligas/" + liga.id, liga);
  },
  getTorneos() {
    return apiClient.get("/torneos");
  },
  getTorneo(id) {
    return apiClient.get("/torneos/" + id);
  },
  postTorneo(torneo) {
    return apiClient.post("/torneos", torneo);
  },
  updateTorneo(torneo) {
    return apiClient.post("/torneos/" + torneo.id, torneo);
  },
  updateTorneoImg(id, data) {
    return apiClient.post("/torneos/" + id, data, {
      headers: {
        "Content-type": "multipart/form-data"
      }
    });
  },
  register(user) {
    return apiClient.post("auth/register", user);
  },
  login(user) {
    return apiClient.post("auth/login", user);
  },
  loginGoogle(token) {
    return apiClient.post("auth/login/google", token);
  },
  loginFacebook(token) {
    return apiClient.post("auth/login/facebook", token);
  },
  getUsers() {
    return apiClient.get("/users");
  },
  passEmail(email) {
    return apiClient.post("/password/email", email);
  },
  changePass(data) {
    return apiClient.post("/password/reset/" + data.token, data);
  },
  getQuinielasPublicas() {
    return apiClient.get("/quinielas/quinielas-publicas");
  },
  getQuiniela(id) {
    return apiClient.get("/quinielas/" + id);
  },
  postQuiniela(quiniela) {
    return apiClient.post("/quinielas", quiniela);
  },
  updateQuiniela(quiniela) {
    return apiClient.post("/quinielas/" + quiniela.id, quiniela);
  },
  getUltimasQuinielas() {
    return apiClient.get("/quinielas/ultimas-quinielas");
  },
  getPlayer(id) {
    return apiClient.get("/jugadores/" + id);
  },
  followUser(data) {
    return apiClient.post("/jugadores/follow", data);
  },
  unfollowUser(data) {
    return apiClient.post("/jugadores/unfollow", data);
  },
  getLoggedInUser() {
    return apiClient.get("/jugadores/yo");
  },
  getNotifications() {
    return apiClient.get("/jugadores/yo/notificaciones");
  },
  marcarNotificacionesLeidas(notificaciones) {
    return apiClient.post("/jugadores/yo/notificaciones", notificaciones);
  },
  getMisQuinielas(cant) {
    let args = "";
    if (cant != null) {
      args = "?cant=" + cant.cant;
    }
    return apiClient.get("/quinielas/mis-quinielas" + args);
  },
  borrarNotificacion(notificacion) {
    return apiClient.post(
      "/jugadores/yo/notificaciones/borrar/" + notificacion.id
    );
  },
  getFeed() {
    return apiClient.get("/jugadores/yo/feed");
  },
  getEspn(args) {
    return apiClient.get("espnfixtures?" + this.serialize(args));
  },
  serialize(obj) {
    var str = [];
    for (var p in obj)
      if (Object.prototype.hasOwnProperty.call(obj, p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },
  postSubscriptions(data){
    return apiClient.post('/subscriptions', data)
  },
  deleteSubscription(data){
    return apiClient.post('/subscriptions/delete', data)
  },
  getEstadistica(){
    return apiClient.get('/estadistica');
  },
  reenviarVerificacion() {
    return apiClient.post('/email/request-verification');
  },
  verificarEmail(token) {
    return apiClient.post('/email/verify', token);
  },
  aceptarSolicitud(solicitud_id){
    return apiClient.post('quinielas/aceptar-solicitud', {id: solicitud_id});
  },
  rechazarSolicitud(solicitud_id) {
    return apiClient.post('quinielas/rechazar-solicitud', {id: solicitud_id});
  },
  getBot(args) {
    return apiClient.get("partidos/bot?" + this.serialize(args));
  },
  updatePerfil(data){
    return apiClient.post("/jugadores/yo/actualizar-perfil", data)
  },
  changePassword(data){
    return apiClient.post('/password/change', data)
  },
  enviarPuntos(data){
    return apiClient.post('/jugadores/'+data.jugador.id+'/enviar-puntos', data)
  },
  getUserSeguidores(){
    return apiClient.get('/jugadores/yo/seguidores')
  },
  getUserSeguidos(){
    return apiClient.get('/jugadores/yo/seguidos')
  },
  webPushMessage(mensaje){
    return apiClient.post('/messages',mensaje)
  },
  buscarJugador(term){
    return apiClient.get('jugadores/buscar?q=' + term)
  },
  buscarQuiniela(term) {
    return apiClient.get('quinielas/buscar?q=' + term)
  },
  getStripeClient(data){
    return apiClient.post('compras/stripe-client', data);
  }
};
